import { Loading, TextBlockSkeleton } from '@/components/shared'
import classNames from 'classnames'
import type { CommonProps, TypeAttributes } from '../@types/common'
import { useConfig } from '../ConfigProvider'
import { LAYOUT, SIZES } from '../utils/constants'
import type { FormContextProps } from './context'
import { FormContextConsumer, FormContextProvider } from './context'

export interface FormContainerProps extends CommonProps {
   size?: TypeAttributes.ControlSize
   layout?: TypeAttributes.FormLayout
   labelWidth?: string | number
   isLoading?: boolean
   isSpinning?: boolean
   spinText?: string
}

const FormContainer = (props: FormContainerProps) => {
   const { controlSize } = useConfig()

   const { spinText, children, className, labelWidth = 100, layout = LAYOUT.VERTICAL, size = SIZES.MD, isLoading, isSpinning } = props

   const contextValue = {
      labelWidth,
      layout,
      size: size || controlSize,
   }

   return (
      <FormContextProvider value={contextValue as FormContextProps}>
         <FormContextConsumer>
            {(context) => {
               return (
                  <>
                     {isLoading && <TextBlockSkeleton rowCount={12} />}
                     {!isLoading && (
                        <Loading loading={isSpinning} type="cover" spinText={spinText}>
                           <div className={classNames('form-container', context?.layout, className)}>{children}</div>
                        </Loading>
                     )}
                  </>
               )
            }}
         </FormContextConsumer>
      </FormContextProvider>
   )
}

FormContainer.displayName = 'FormContainer'

export default FormContainer
